<style></style>

<template>
    <div>
        <div class="mt-5 d-flex justify-content-between align-items-center">
            <a :href="$basePath+'/action-plans/'+mostRecentAssessment.survey.slug+'/'+mostRecentAssessment.id+'/start'" class="btn-orange-blue">
                <small>
                    <span class="fa fa-caret-left"></span>
                    Go Back
                </small>
            </a>

            <progress-bar width="66"></progress-bar>

            <button type="button" class="btn-orange-blue btn-sm" v-on:click="$emit('planstarted')">
                    Save
                    <span class="fa fa-caret-right"></span>
            </button>        
        </div>
    </div>        
</template>

<script>
    import ProgressBar from './ProgressBar'

    export default {
        props: {
            mostRecentAssessment: {
                type: Object,
                required: true
            }
        },
        components: {
            ProgressBar
        },
        data() {
            return {}
        },
        methods: {},
        computed: {
            $basePath() {
              return window.basePath;
            }
        }
    }
</script>